export default __webpack_public_path__ + "static/media/2 raw.e42b5919.mp3";